import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

const handleErrors = err => {
  if (!err.response || err.response.status === 500) {
    // break app
  }

  return err.response
}

const responseData = res => res && res.data

const requests = {
  del: url =>
    axios.delete(url)
      .catch(handleErrors)
      .then(responseData),
  get: (url, config) =>
    axios.get(url, config)
      .catch(handleErrors)
      .then(responseData),
  put: (url, body) => {
    axios.put(url, body)
      .catch(handleErrors)
      .then(responseData)
  },
  post: (url, body) => {
    axios.post(url, body)
      .catch(handleErrors)
      .then(responseData)
  }
}

const places = {
  list: page => requests.get('/pins/', { params: { page } }),
  details: id => requests.get(`/pins/${ id }/`),
  submit: data => axios.post('/pins/add/', data)
}

const filters = {
  list: () => requests.get('/tags/')
}

const contest = {
  submit: data => requests.post('/contest/apply/', data)
}

export default {
  places,
  filters,
  contest
}



// WEBPACK FOOTER //
// ./src/service.js